/**
 * 环境判断与参数获取工具
 */

/**
 * 获取当前运行环境信息
 */
export const getEnv = () => {
  const ua = navigator.userAgent
  const isIframe = window.self !== window.top
  const isWechat = /MicroMessenger/i.test(ua)
  const isApp = /customer_token/i.test(ua) // 根据需求中的 UA 示例判断
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)

  return {
    isIframe,
    isWechat,
    isApp,
    isMobile
  }
}

/**
 * 从 UserAgent 获取 customer_token
 */
export const getTokenFromUA = () => {
  const ua = navigator.userAgent
  const match = ua.match(/customer_token\/([^/\s]+)/)
  return match ? match[1] : ""
}

const fullScreenMinVersions: Record<string, string> = {
  jlmerchant: "3.2.12",
  jlpartner: "3.2.21"
}

const getUaValue = (key: string) => {
  return navigator.userAgent.match(new RegExp(`(?:^|\\s)${key}/([^\\s]+)`))?.[1]
}

const compareVersion = (version: string, targetVersion: string) => {
  const versionParts = version.split(".").map(Number)
  const targetVersionParts = targetVersion.split(".").map(Number)
  const length = Math.max(versionParts.length, targetVersionParts.length)

  for (let i = 0; i < length; i++) {
    const current = Number.isFinite(versionParts[i]) ? versionParts[i] : 0
    const target = Number.isFinite(targetVersionParts[i]) ? targetVersionParts[i] : 0

    if (current > target) return 1
    if (current < target) return -1
  }

  return 0
}

export const isSupportedFullScreenApp = () => {
  const appType = getUaValue("app_type")
  const appVersion = getUaValue("app_version")
  const minVersion = appType ? fullScreenMinVersions[appType] : undefined

  return !!appVersion && !!minVersion && compareVersion(appVersion, minVersion) >= 0
}

/**
 * 封装跨端方法 (示例：如果未来有不同的分享、交互逻辑)
 * 处理 Interaction 3
 */
export const crossPlatformMethods = {
  // 可以在这里封装不同环境下的特定方法
  // 例如：closePage, share, notifyParent 等
  notifyReady() {
    const { isIframe } = getEnv()
    if (isIframe) {
      window.parent?.postMessage({ type: "IFRAME_READY" }, "*")
    }
  }
}
